'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, useLayoutEffect, useRef } from 'react';
import { BlogPageDto } from '@/components/BlogPage/types';
import PageBreadcrumbs from '@/components/PageBreadcrumbs';
import AnimatedWavyBackground from '@/components/shared/AnimatedWavyBackground';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { breadcrumbTrails } from '@/lib/breadcrumbs';
import { gsap } from '@/lib/gsap';
import css from './style.module.scss';
interface Props {
  data: BlogPageDto;
}
const BlogHero: FC<Props> = t0 => {
  const $ = _c(8);
  const {
    data
  } = t0;
  const wrapperRef = useRef(null);
  const breadcrumbsRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const wrapper = wrapperRef.current;
      if (!wrapper) {
        return;
      }
      const breadcrumbs = breadcrumbsRef.current;
      const titleLines = wrapper.querySelectorAll(`.${css.title} p`);
      const ctx = gsap.context(() => {
        const tl = gsap.timeline({
          defaults: {
            ease: "power3.out",
            duration: 1.2
          },
          scrollTrigger: {
            trigger: wrapper,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        });
        gsap.set(titleLines, {
          opacity: 0,
          y: 40,
          filter: "blur(10px)"
        });
        if (breadcrumbs) {
          gsap.set(breadcrumbs, {
            opacity: 0,
            y: 40,
            filter: "blur(10px)"
          });
        }
        tl.to(titleLines, {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          stagger: 0.15,
          duration: 1.1,
          ease: "power3.out"
        }, 0);
        if (breadcrumbs) {
          tl.to(breadcrumbs, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1,
            ease: "power2.out"
          }, "-=0.6");
        }
      }, wrapper);
      return () => ctx.revert();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PageBreadcrumbs ref={breadcrumbsRef} items={breadcrumbTrails.blogLobby()} withContainer={false} wrapperClassName={css.breadcrumbsWrap} className={css.breadcrumbs} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data.title) {
    t4 = <div className={css.content}>{t3}<Typography uppercase={true} className={css.title} variant="h1" tag="h1"><StrapiRichContent content={data.title} /></Typography></div>;
    $[3] = data.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AnimatedWavyBackground />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <section ref={wrapperRef} className={css.wrapper}>{t4}{t5}</section>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default BlogHero;